module.exports = __webpack_public_path__ + "img/jujialei-6.24f49343.png";